import { render, staticRenderFns } from "./SamModalManager.vue?vue&type=template&id=04c2e754&shadow"
import script from "./SamModalManager.vue?vue&type=script&lang=js&shadow"
export * from "./SamModalManager.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports